import React, { useState, useEffect } from "react";
import axios from "axios";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Grid from "./Grid";
import AllWords from "../wordhunt/AllWords";

function WordBitesSolver() {
  const [singlePieces, setSinglePieces] = useState("");
  const [horizPieces, setHorizPieces] = useState("");
  const [vertPieces, setVertPieces] = useState("");

  const [loading, setLoading] = useState(false);

  const [singlePiecesArr, setSinglePiecesArr] = useState([]);
  const [horizPiecesArr, setHorizPiecesArr] = useState([]);
  const [vertPiecesArr, setVertPiecesArr] = useState([]);

  const [validWords, setValidWords] = useState([]);
  const [wordIdx, setWordIdx] = useState(0);

//   const url = "http://127.0.0.1:5000/";
  const url = "https://gamepigeon.pythonanywhere.com";

    const onSubmit = () => {
        setLoading(true)
        let tempSingle = singlePieces.trim().split(/\s+/).map(piece => piece.toUpperCase())
        let tempVert = vertPieces.trim().split(/\s+/).map(piece => piece.toUpperCase())
        let tempHoriz = horizPieces.trim().split(/\s+/).map(piece => piece.toUpperCase())
        setSinglePiecesArr(tempSingle)
        setVertPiecesArr(tempVert)
        setHorizPiecesArr(tempHoriz)
        if (tempSingle.length != 0 && tempVert.length != 0 && tempHoriz.length != 0) {
            axios
            .post(`${url}/wordbites`, {
                singleLetterPieces: tempSingle,
                vertPieces: tempVert,
                horizPieces: tempHoriz,
            })
            .then(
                (response) => {
                    let tempValidWords = response.data.validWords;
                    setValidWords(tempValidWords);
                    // let tempWordsOnly = []
                    // tempValidWords.forEach((elem) => {
                    //     tempWordsOnly.push(elem[0])
                    // })
                    // setWordsOnly(tempWordsOnly)
                    setLoading(false)
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    }

  return (
      <div>
        <Row>
          <Col md="6">
            <div className="parent px-5">
                {validWords.length != 0 &&
                    <div className="">
                        <h3>{validWords[wordIdx][0]} <span>
                        <Button variant="secondary" className="float-right" onClick={() => setWordIdx((wordIdx+1) % validWords.length)}>Next</Button>
                        </span></h3>
                        
                        <Grid 
                            word={validWords[wordIdx][0]}
                            direction={validWords[wordIdx][1]}
                            pieces={validWords[wordIdx][2]}
                            vertPieces={new Set(vertPiecesArr)}
                            horizPieces={new Set(horizPiecesArr)}
                            singlePieces={new Set(singlePiecesArr)}
                            />
                    </div>
                }
            </div>
          </Col>

          <Col md="6">
                <Form.Group as={Row} className="mb-3">
                    <Form.Label column sm="4">
                    Single Letter Pieces
                    </Form.Label>
                    <Col sm="8" className="mb-3">
                        <Form.Control 
                            type="text" 
                            placeholder="separate with space (like s g l)" 
                            defaultValue={singlePieces}
                            onChange={e => setSinglePieces(e.target.value)}
                            />
                    </Col>
                    <Form.Label column sm="4">
                    Horizontal Pieces
                    </Form.Label>
                    <Col sm="8" className="mb-3">
                        <Form.Control 
                            type="text" 
                            placeholder="separate with space (like ho ri zo)" 
                            defaultValue={horizPieces}
                            onChange={e => setHorizPieces(e.target.value)}
                            />
                    </Col>
                    <Form.Label column sm="4">
                    Vertical Pieces
                    </Form.Label>
                    <Col sm="8" className="mb-3">
                        <Form.Control 
                            type="text" 
                            placeholder="separate with space (like ve ti ca)" 
                            defaultValue={vertPieces}
                            onChange={e => setVertPieces(e.target.value)}
                            />
                    </Col>
                    <Col className="text-center">
                        <Button variant="primary" onClick={onSubmit} disabled={loading}>
                            Submit
                        </Button>
                    </Col>
                </Form.Group>
          </Col>
        </Row>
        <br />
        <div className="mt-3">
          <AllWords words={validWords} direction={true}/>
        </div>
      </div>
  );
}

export default WordBitesSolver;
